var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#CF8A97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2427 23.2426C22.5859 20.8995 26.3848 20.8995 28.728 23.2426L34.3848 28.8995C36.728 31.2426 36.728 35.0416 34.3848 37.3848L32.2635 39.5061C31.092 40.6777 29.1925 40.6777 28.0209 39.5061L20.2427 31.7279C17.8996 29.3848 17.8996 25.5858 20.2427 23.2426Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0703 23.2426C37.7271 20.8995 33.9281 20.8995 31.585 23.2426L25.9281 28.8995C23.585 31.2426 23.585 35.0416 25.9281 37.3848L28.0495 39.5061C29.221 40.6777 31.1205 40.6777 32.2921 39.5061L40.0703 31.7279C42.4134 29.3848 42.4134 25.5858 40.0703 23.2426Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat5);
export default __webpack_public_path__ + "static/media/cat_5.52b452c5a7380eb17634e160753f6f43.svg";
export { ForwardRef as ReactComponent };